module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"JS Development Studio — tworzenie stron, sklepów i aplikacji","short_name":"JS Studio","description":"Strony internetowe, aplikacje internetowe i aplikacje mobilne dla firm — Mogilno i cała Polska, zdalnie.","lang":"pl","start_url":"/","background_color":"#0A0A0F","theme_color":"#8B5CF6","display":"standalone","categories":["business","productivity","web development"],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"444ea6c1b7102a88d42cf250f0b61c9c"},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
